module.exports = __webpack_public_path__ + "img/avatar.e9c7e13f.png";